import { injectable } from 'tsyringe'
import { RoleApiRepository } from '@/app/repositories/api/RoleApiRepository'
import { Role } from '@/domain/entities/Role'

@injectable()
export class RolePresenter {
  private repository: RoleApiRepository

  constructor(repository: RoleApiRepository) {
    this.repository = repository
  }

  public loadRole(params: Object): Promise<Role[]> {
    return this.repository.getAll(params)
  }
}
